import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'steelfixing-sydney';
const serviceId = 2
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Steelfixing Sydney | ${BUSINESS_NAME}`,
        description: "Professional reinforcement steel fixing for structural integrity.",
        keywords: "steelfixing Sydney, reinforcement steel fixing, structural steelwork, concrete reinforcement, rebar installation, commercial steelfixing, residential steelfixing, industrial steelfixing, steel fixing contractors, Sydney construction services",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Steelfixing Sydney',
    description: 'Professional reinforcement steel fixing for structural integrity.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
